<div fxLayout="row wrap">
    <div fxFlex="50" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" class="p-2">        
        <mat-card class="gradient-green tile p-2"> 
            <mat-icon>monetization_on</mat-icon> 
            <h2>{{sum}} {{currency}}</h2>         
            <p>Mes avoirs depuis le {{ this.user?.created_at | date:"dd MMMM, yyyy 'à' HH:mm" }}</p>            
        </mat-card>
    </div> 
    <div fxFlex="50" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="33.3" class="p-2">        
        <mat-card class="gradient-red tile p-2"> 
            <mat-icon>trending_down</mat-icon> 
            <h2>{{currentAmount}} {{currency}}</h2>         
            <p>Montant actuel</p>            
        </mat-card>
    </div>
    <div fxFlex="50" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="33.3" class="p-2">
        <mat-card class="gradient-brown tile p-2">
            <mat-icon>trending_up</mat-icon> 
            <h2>{{transferTotal}} {{currency}}</h2>         
            <p>Montant virement</p> 
        </mat-card>
    </div>  
    <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2">
        <mat-card class="gradient-orange tile p-2">
            <mat-icon>trending_up</mat-icon> 
            <h2>{{sumPaymentWithAsset}} {{currency}}</h2>         
            <p>Montant utilisé pour les paiements</p> 
        </mat-card>
    </div>     
</div>
<div fxLayout="row wrap" fxLayoutAlign="end" class="w-100 p-2" >
    <button mat-raised-button color="primary" (click)="createTransfer()" *ngIf="currentAmount != 0">
        <mat-icon>add</mat-icon>
        Demander un virement
    </button>
</div>
<div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-sm="100" class="p-2"> 
        <mat-card class="m-2 p-0">
            <mat-card-header fxLayoutAlign="center">                
                <mat-card-subtitle><h2>Mes avoirs</h2></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2" id="afficheAddcars">
                    <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.sm="33">
                        
                        <button  mat-icon-button  color="primary" matTooltip="Affichage en Grille" (click)="changeViewType('grid')">
                            <span><mat-icon>grid_view</mat-icon></span>
                        </button>
                        <button  mat-icon-button  color="primary" matTooltip="Affichage en Liste" (click)="changeViewType('list')">
                            <span><mat-icon>format_list_bulleted</mat-icon></span>
                        </button>
                       
                    </div>
                </div>
                <div class="table-wrapper" *ngIf="viewType==='list'"> 
                    <table mat-table [dataSource]="dataSource" matSort class="w-100">
                    
                        <!-- ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                            <td mat-cell *matCellDef="let asset; let i=index"> #{{i+1}} </td>
                        </ng-container>  
                
                        <!-- Amount Column -->
                        <ng-container matColumnDef="amount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Montant </th>
                            <td mat-cell *matCellDef="let asset"> {{asset.asset_amount}} {{currency}}</td>
                        </ng-container>  
                    
            
                        <!-- location Column -->
                        <ng-container matColumnDef="location">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
                            <td mat-cell *matCellDef="let asset">
                                <span>
                                    {{ asset.renting_date_departure }} {{asset.renting_hour_departure}}<br>
                                    {{ asset.renting_date_return }} {{asset.renting_hour_return}}
                                </span>
                            </td>
                        </ng-container> 
            
                        <!-- Table vehicle Column -->
                        <ng-container matColumnDef="vehicle">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Véhicule </th>
                            <td mat-cell *matCellDef="let asset"> {{asset.mark_lib}} {{asset.mod_lib}}</td>
                        </ng-container> 
                
                        <!-- Date Column -->
                        <ng-container matColumnDef="date">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                            <td mat-cell *matCellDef="let asset">{{asset.created_at | date:"dd MMMM, yyyy 'à' HH:mm" }}</td>
                        </ng-container>
                    
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let asset; columns: displayedColumns;"></tr>
                    </table> 
                    <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p> 
                </div>

                <div fxLayout="row wrap" fxLayoutAlign="center" class="w-100 p-2" *ngIf="viewType==='grid'">
                <mat-card class="menu-item" [fxLayout]="(viewType == 'grid') ? 'column' : 'row'"
                    [ngClass]="[viewType + '-item', 'column-'+column]" fxFlex.gt-sm="25" fxFlex.sm="25"  *ngFor="let item of avoirs | paginate: { itemsPerPage: 10, currentPage: p }">
                
                    <div fxFlex="100" class="p-3">
                        <div fxLayout="column" fxLayoutAlign="start stretch" class="h-100">
                            <mat-card-content class="mb-0">
                                <mat-icon class="icon-title">payments</mat-icon>
                                <h1 class="title">
                                    {{item.asset_amount}} {{currency}}
                                </h1>
                                <div> 
                                    <div class="features">
                                        <span>Véhicule : {{item.mark_lib}} {{item.mod_lib}}</span><br>
                                        <span>Location du : {{ item.renting_date_departure }} {{item.renting_hour_departure}}</span>
                                        <span>Au : {{ item.renting_date_return }} {{item.renting_hour_return}}</span>
                                    </div>
                                </div>
                            </mat-card-content>
                            <mat-card-actions class="m-0 p-0">
                                <div class="divider mt-1">
                                    <span class="text-muted text-center">
                                        {{item.created_at | date:"dd MMMM, yyyy 'a' HH:mm" }}
                                    </span>
                                </div>
                            </mat-card-actions>
                        </div>
                    </div>
                </mat-card>
                <p *ngIf="avoirs && avoirs.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p> 
                    
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="space-between" class="w-100 p-2">
                <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20">
                    <button  mat-icon-button  color="primary" matTooltip="Rafraichir" (click)="refresh()">
                        <span><mat-icon>refresh</mat-icon> Mise à jour</span>
                    </button>
                </div>
                
                <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='grid'">
                    <pagination-controls (pageChange)="p = $event" style="text-align: end;"></pagination-controls>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='list'">
                    <mat-paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                </div>
            </div>
        
                </mat-card-content>
                
            </mat-card>
    </div>
</div>

<div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-sm="100" class="p-2"> 
        <app-transfer-table [valueChange]="valueChange" [key]="'ASSET'"></app-transfer-table>
    </div>
</div>